import React from 'react'

export default function About() {
    return (
        <div>        <div id ='about'>
            <div className ='about-text'>
            <br></br>       
            <h1>About</h1>
            <p> 4 Unnammed hamster orphans looking for foster parents</p>
            <br></br> 
            <br></br> 
            <br></br> 
            </div>

            
        </div><div>
     

          nothing left down here but emptiness and darkness, scroll up
        </div></div>





        
    )
}
